/**
 * API 基础地址
 * 本地开发：走 Vite 代理 /api → https://www.aiiifly.com
 * 生产构建：使用同源 /api，由部署站点反向代理到旧后端。
 * 生产环境不能让浏览器直接请求 www.aiiifly.com，否则登录等 JSON POST
 * 会触发 OPTIONS 预检并被旧后端的 CORS 策略拦截。
 */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? '/api' : 'https://www.aiiifly.com/api')

/** 代理目标（仅 vite.config 使用，与线上域名保持一致） */
export const API_PROXY_TARGET =
  import.meta.env.VITE_API_PROXY_TARGET || 'https://www.aiiifly.com'
